"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuContent = void 0;
var _MenuContent = require("./MenuContent");
// TODO: in v9, move styled() from MenuContent.jsx to here
var StyledMenuContent = _MenuContent.MenuContent;
exports.StyledMenuContent = StyledMenuContent;